<template>
  <div :class="{ menu_fixed: scrollPosition > 450 }" class="right-column">
    <div class="right-menu">
      <div v-for="link in links" :key="link.ref">
        <a v-bind:href="`#${link.ref}`" class="nav-link">
          {{ link.name }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MenuFixed",
  props: {
    links: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      scrollPosition: null,
    };
  },
  methods: {
    updateScroll() {
      this.scrollPosition = window.scrollY;
    },
  },
  mounted() {
    window.scrollTo(0, 0);
    window.addEventListener("scroll", this.updateScroll);
  },
};
</script>

<style scoped lang="scss">
.right-column {
  width: 40%;
  padding-top: 1em;
  padding-left: 1em;

  .right-menu {
    background: $primaryColor;
    padding-left: 1em;
    padding-bottom: 1em;
  }

  .nav-link {
    text-decoration: none;
    color: $whiteColor;
    font-family: "Averia Sans Libre", sans-serif;
    line-height: 1em;
    padding-top: 0.5em;
  }

  &.menu_fixed {
    position: fixed;
    top: 0;
    right: 0;
    padding-right: 5em;
    min-width: 40%;
  }
}

@media only screen and (max-width: 792px) {
  .columns {
    .right-column {
      display: none;
    }
  }
}
</style>
